<template>
  <v-snackbar :timeout=timeout
              :color=message.type
              v-model="showMessage"
              style="z-index: 1000000;">
    {{ message.text }}
    <template v-slot:action="{ attrs }">
      <v-btn icon dark text @click="showMessage = false">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    data: function () {
      return {
        showMessage: false
      }
    },
    computed: {
      message () {
        return this.$store.getters.message
      },
      timeout () {
        if (this.message && this.message != null && (this.message.clickToDismiss || this.message.type === 'error')) {
          return 30000
        } else {
          return 6000
        }
      }
    },
    watch: {
      message: {
        handler: function () {
          if (this.message.translate) {
            this.message.text = this.$t(this.message.text)
          }
          if (this.message.show) {
            this.showMessage = true
          }
        },
        deep: true
      },
      showMessage: function () {
        if (!this.showMessage) {
          this.$store.commit('hideMessage')
        }
      }
    }
  }
</script>
